var map = {
	"./report/Index": [
		825,
		0,
		19
	],
	"./report/callMonitoring/Index": [
		796,
		93
	],
	"./report/loyalty_program/Index": [
		797,
		0,
		21
	],
	"./report/loyalty_program/list/Index": [
		754,
		94
	],
	"./report/pointing_system/Index": [
		831,
		0,
		22
	],
	"./report/pointing_system/lists/Index": [
		783,
		95
	],
	"./report/product/Index": [
		790,
		0,
		24
	],
	"./report/realproperty/Index": [
		774,
		69
	],
	"./report/service/Index": [
		775,
		0,
		23
	],
	"./report/service/booking/Index": [
		753,
		0,
		25
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 700;
module.exports = webpackAsyncContext;